import React, { useState, useEffect, useRef } from 'react';
import './ContactDetails.css';
import { Container, Button, Form, Dropdown, Card } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import Navbar from "../../../Pages/Navbar/JobSeekerNavbar";
import BaseUrl from '../../../ApiServices/BaseUrl';

function ContactDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const userId = location.state?.userId || user.id || '';
  const current_country = location.state?.current_country || '';

  const [formData, setFormData] = useState({
    user_id: userId,
    email_id: '',
    mobile_country_code: '',
    mobile_number: '',
    whatsapp_country_code: '',
    whatsapp_number: '',
    botim_country_code: '',
    botim_number: '',
    telegram_country_code: '',
    telegram_number: '',
    has_valid_passport: 'Yes'
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const [userData, setUserData] = useState(null);

  // Refs for input fields
  const emailRef = useRef(null);
  const mobileNumberRef = useRef(null);
  const whatsappNumberRef = useRef(null);
  const botimNumberRef = useRef(null);
  const telegramNumberRef = useRef(null);
  const passportSectionRef = useRef(null);

  const countryCodes = [
    { code: '+93', country: 'Afghanistan' },
    { code: '+355', country: 'Albania' },
    { code: '+213', country: 'Algeria' },
    { code: '+376', country: 'Andorra' },
    { code: '+244', country: 'Angola' },
    { code: '+1-268', country: 'Antigua and Barbuda' },
    { code: '+54', country: 'Argentina' },
    { code: '+374', country: 'Armenia' },
    { code: '+297', country: 'Aruba' },
    { code: '+61', country: 'Australia' },
    { code: '+43', country: 'Austria' },
    { code: '+994', country: 'Azerbaijan' },
    { code: '+1-242', country: 'Bahamas' },
    { code: '+973', country: 'Bahrain' },
    { code: '+880', country: 'Bangladesh' },
    { code: '+1-246', country: 'Barbados' },
    { code: '+375', country: 'Belarus' },
    { code: '+32', country: 'Belgium' },
    { code: '+501', country: 'Belize' },
    { code: '+229', country: 'Benin' },
    { code: '+975', country: 'Bhutan' },
    { code: '+591', country: 'Bolivia' },
    { code: '+387', country: 'Bosnia and Herzegovina' },
    { code: '+267', country: 'Botswana' },
    { code: '+55', country: 'Brazil' },
    { code: '+673', country: 'Brunei' },
    { code: '+359', country: 'Bulgaria' },
    { code: '+226', country: 'Burkina Faso' },
    { code: '+257', country: 'Burundi' },
    { code: '+238', country: 'Cabo Verde' },
    { code: '+855', country: 'Cambodia' },
    { code: '+237', country: 'Cameroon' },
    { code: '+1', country: 'Canada' },
    { code: '+236', country: 'Central African Republic' },
    { code: '+235', country: 'Chad' },
    { code: '+56', country: 'Chile' },
    { code: '+86', country: 'China' },
    { code: '+57', country: 'Colombia' },
    { code: '+269', country: 'Comoros' },
    { code: '+242', country: 'Congo' },
    { code: '+243', country: 'Congo (Democratic Republic)' },
    { code: '+506', country: 'Costa Rica' },
    { code: '+385', country: 'Croatia' },
    { code: '+53', country: 'Cuba' },
    { code: '+357', country: 'Cyprus' },
    { code: '+420', country: 'Czech Republic' },
    { code: '+45', country: 'Denmark' },
    { code: '+253', country: 'Djibouti' },
    { code: '+1-767', country: 'Dominica' },
    { code: '+1-809', country: 'Dominican Republic' },
    { code: '+670', country: 'East Timor' },
    { code: '+593', country: 'Ecuador' },
    { code: '+20', country: 'Egypt' },
    { code: '+503', country: 'El Salvador' },
    { code: '+240', country: 'Equatorial Guinea' },
    { code: '+291', country: 'Eritrea' },
    { code: '+372', country: 'Estonia' },
    { code: '+268', country: 'Eswatini' },
    { code: '+251', country: 'Ethiopia' },
    { code: '+679', country: 'Fiji' },
    { code: '+358', country: 'Finland' },
    { code: '+33', country: 'France' },
    { code: '+241', country: 'Gabon' },
    { code: '+220', country: 'Gambia' },
    { code: '+995', country: 'Georgia' },
    { code: '+49', country: 'Germany' },
    { code: '+233', country: 'Ghana' },
    { code: '+30', country: 'Greece' },
    { code: '+1-473', country: 'Grenada' },
    { code: '+502', country: 'Guatemala' },
    { code: '+224', country: 'Guinea' },
    { code: '+245', country: 'Guinea-Bissau' },
    { code: '+592', country: 'Guyana' },
    { code: '+509', country: 'Haiti' },
    { code: '+504', country: 'Honduras' },
    { code: '+852', country: 'Hong Kong' },
    { code: '+36', country: 'Hungary' },
    { code: '+354', country: 'Iceland' },
    { code: '+91', country: 'India' },
    { code: '+62', country: 'Indonesia' },
    { code: '+98', country: 'Iran' },
    { code: '+964', country: 'Iraq' },
    { code: '+353', country: 'Ireland' },
    { code: '+972', country: 'Israel' },
    { code: '+39', country: 'Italy' },
    { code: '+225', country: 'Ivory Coast' },
    { code: '+1-876', country: 'Jamaica' },
    { code: '+81', country: 'Japan' },
    { code: '+962', country: 'Jordan' },
    { code: '+7', country: 'Kazakhstan' },
    { code: '+254', country: 'Kenya' },
    { code: '+686', country: 'Kiribati' },
    { code: '+965', country: 'Kuwait' },
    { code: '+996', country: 'Kyrgyzstan' },
    { code: '+856', country: 'Laos' },
    { code: '+371', country: 'Latvia' },
    { code: '+961', country: 'Lebanon' },
    { code: '+266', country: 'Lesotho' },
    { code: '+231', country: 'Liberia' },
    { code: '+218', country: 'Libya' },
    { code: '+423', country: 'Liechtenstein' },
    { code: '+370', country: 'Lithuania' },
    { code: '+352', country: 'Luxembourg' },
    { code: '+853', country: 'Macau' },
    { code: '+261', country: 'Madagascar' },
    { code: '+265', country: 'Malawi' },
    { code: '+60', country: 'Malaysia' },
    { code: '+960', country: 'Maldives' },
    { code: '+223', country: 'Mali' },
    { code: '+356', country: 'Malta' },
    { code: '+692', country: 'Marshall Islands' },
    { code: '+222', country: 'Mauritania' },
    { code: '+230', country: 'Mauritius' },
    { code: '+52', country: 'Mexico' },
    { code: '+691', country: 'Micronesia' },
    { code: '+373', country: 'Moldova' },
    { code: '+377', country: 'Monaco' },
    { code: '+976', country: 'Mongolia' },
    { code: '+382', country: 'Montenegro' },
    { code: '+212', country: 'Morocco' },
    { code: '+258', country: 'Mozambique' },
    { code: '+95', country: 'Myanmar' },
    { code: '+264', country: 'Namibia' },
    { code: '+674', country: 'Nauru' },
    { code: '+977', country: 'Nepal' },
    { code: '+31', country: 'Netherlands' },
    { code: '+64', country: 'New Zealand' },
    { code: '+505', country: 'Nicaragua' },
    { code: '+227', country: 'Niger' },
    { code: '+234', country: 'Nigeria' },
    { code: '+389', country: 'North Macedonia' },
    { code: '+47', country: 'Norway' },
    { code: '+968', country: 'Oman' },
    { code: '+92', country: 'Pakistan' },
    { code: '+680', country: 'Palau' },
    { code: '+970', country: 'Palestine' },
    { code: '+507', country: 'Panama' },
    { code: '+675', country: 'Papua New Guinea' },
    { code: '+595', country: 'Paraguay' },
    { code: '+51', country: 'Peru' },
    { code: '+63', country: 'Philippines' },
    { code: '+48', country: 'Poland' },
    { code: '+351', country: 'Portugal' },
    { code: '+974', country: 'Qatar' },
    { code: '+40', country: 'Romania' },
    { code: '+7', country: 'Russia' },
    { code: '+250', country: 'Rwanda' },
    { code: '+1-869', country: 'Saint Kitts and Nevis' },
    { code: '+1-758', country: 'Saint Lucia' },
    { code: '+1-784', country: 'Saint Vincent and the Grenadines' },
    { code: '+685', country: 'Samoa' },
    { code: '+378', country: 'San Marino' },
    { code: '+239', country: 'Sao Tome and Principe' },
    { code: '+966', country: 'Saudi Arabia' },
    { code: '+221', country: 'Senegal' },
    { code: '+381', country: 'Serbia' },
    { code: '+248', country: 'Seychelles' },
    { code: '+232', country: 'Sierra Leone' },
    { code: '+65', country: 'Singapore' },
    { code: '+421', country: 'Slovakia' },
    { code: '+386', country: 'Slovenia' },
    { code: '+677', country: 'Solomon Islands' },
    { code: '+252', country: 'Somalia' },
    { code: '+27', country: 'South Africa' },
    { code: '+82', country: 'South Korea' },
    { code: '+211', country: 'South Sudan' },
    { code: '+34', country: 'Spain' },
    { code: '+94', country: 'Sri Lanka' },
    { code: '+249', country: 'Sudan' },
    { code: '+597', country: 'Suriname' },
    { code: '+46', country: 'Sweden' },
    { code: '+41', country: 'Switzerland' },
    { code: '+963', country: 'Syria' },
    { code: '+886', country: 'Taiwan' },
    { code: '+992', country: 'Tajikistan' },
    { code: '+255', country: 'Tanzania' },
    { code: '+66', country: 'Thailand' },
    { code: '+228', country: 'Togo' },
    { code: '+676', country: 'Tonga' },
    { code: '+1-868', country: 'Trinidad and Tobago' },
    { code: '+216', country: 'Tunisia' },
    { code: '+90', country: 'Turkey' },
    { code: '+993', country: 'Turkmenistan' },
    { code: '+688', country: 'Tuvalu' },
    { code: '+256', country: 'Uganda' },
    { code: '+380', country: 'Ukraine' },
    { code: '+971', country: 'United Arab Emirates' },
    { code: '+44', country: 'United Kingdom' },
    { code: '+1', country: 'United States' },
    { code: '+598', country: 'Uruguay' },
    { code: '+998', country: 'Uzbekistan' },
    { code: '+678', country: 'Vanuatu' },
    { code: '+379', country: 'Vatican City' },
    { code: '+58', country: 'Venezuela' },
    { code: '+84', country: 'Vietnam' },
    { code: '+967', country: 'Yemen' },
    { code: '+260', country: 'Zambia' },
    { code: '+263', country: 'Zimbabwe' }
  ];

  // Fetch user data from the authentication endpoint
  const fetchUserData = async () => {
    try {
      const response = await fetch(`${BaseUrl}/`);
      if (response.ok) {
        const data = await response.json();

        // Find the user by ID
        const currentUser = data.find(user => user.id.toString() === userId.toString());

        if (currentUser) {
          setUserData(currentUser);

          // Extract country code from mobile number if available
          let extractedCountryCode = '';
          let extractedMobileNumber = currentUser.mobile_number || '';

          // Try to extract country code from the mobile number
          if (currentUser.mobile_number && currentUser.mobile_number_country_code) {
            extractedCountryCode = currentUser.mobile_number_country_code;
          } else if (currentUser.mobile_number) {
            // Try to match with our country codes
            const matchedCountry = countryCodes.find(country =>
              currentUser.mobile_number.startsWith(country.code.replace('+', '')) ||
              currentUser.mobile_number.startsWith(country.code)
            );

            if (matchedCountry) {
              extractedCountryCode = `${matchedCountry.code}(${matchedCountry.country})`;
              // Remove country code from mobile number if present
              extractedMobileNumber = currentUser.mobile_number.replace(matchedCountry.code, '').replace('+', '');
            }
          }

          // Set initial form data with fetched user data
          setFormData(prev => ({
            ...prev,
            email_id: currentUser.email || '',
            // Mobile number from registration
            mobile_number: currentUser.mobile_number || '',
            mobile_country_code: currentUser.mobile_number_country_code || extractedCountryCode || prev.mobile_country_code,
            // WhatsApp number from registration (separate field in users table)
            whatsapp_number: prev.whatsapp_number || currentUser.whatsapp_number || '',
            whatsapp_country_code: prev.whatsapp_country_code || currentUser.whatsapp_country_code || extractedCountryCode || '',
            // Country code defaults for botim/telegram
            botim_country_code: prev.botim_country_code || extractedCountryCode || '',
            telegram_country_code: prev.telegram_country_code || extractedCountryCode || ''
          }));
        }
      } else {
        console.error('Failed to fetch user data');
      }
    } catch (err) {
      console.error('Error fetching user data:', err);
    }
  };

  // In the fetchContactData function, update the has_valid_passport handling:
  const fetchContactData = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/job-seeker/${userId}`);
      if (response.ok) {
        const data = await response.json();
        if (data) {
          // Find matching country code based on nationality
          const matchedCountry = countryCodes.find(
            (item) => item.country.toLowerCase() === (data.nationality || '').toLowerCase()
          );

          const defaultCode = matchedCountry ? `${matchedCountry.code}(${matchedCountry.country})` : '';

          // Update form data with fetched contact data
          setFormData(prev => ({
            ...prev,
            email_id: data.email_id || prev.email_id,
            mobile_country_code: data.mobile_country_code || prev.mobile_country_code || defaultCode,
            mobile_number: data.mobile_number || prev.mobile_number,
            whatsapp_country_code: data.whatsapp_country_code || prev.whatsapp_country_code || defaultCode,
            whatsapp_number: data.whatsapp_number || prev.whatsapp_number,
            botim_country_code: data.botim_country_code || prev.botim_country_code || defaultCode,
            botim_number: data.botim_number || prev.botim_number,
            telegram_country_code: data.telegram_country_code || prev.telegram_country_code || defaultCode,
            telegram_number: data.telegram_number || '',
            // Fix the passport field logic - handle both string "0"/"1" and number 0/1
            has_valid_passport:
              data.has_valid_passport === true ||
                data.has_valid_passport === 'true' ||
                data.has_valid_passport === 'Yes' ||
                data.has_valid_passport === '1' ||
                data.has_valid_passport === 1
                ? 'Yes'
                : data.has_valid_passport === false ||
                  data.has_valid_passport === 'false' ||
                  data.has_valid_passport === 'No' ||
                  data.has_valid_passport === '0' ||
                  data.has_valid_passport === 0
                  ? 'No'
                  : 'Yes' // Default value if not set
          }));

          setIsSaved(true);
        }
      } else if (response.status !== 404) {
        throw new Error('Failed to fetch contact data');
      }
    } catch (err) {
      console.error('Error fetching contact data:', err);
      setError(err.message);
    }
  };

  useEffect(() => {
    if (userId) {
      // Fetch user data first
      fetchUserData();

      // Then fetch contact data
      fetchContactData();
    }
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setError(null);
    setIsSaved(false);
  };

  const handleSelect = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    setError(null);
    setIsSaved(false);
  };

  const saveData = async () => {
    setIsLoading(true);
    setError(null);

    Swal.fire({
      title: 'Saving...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const dataToSend = {
        ...formData,
        // Convert to string "1" for Yes and "0" for No to match your database schema
        has_valid_passport: formData.has_valid_passport === 'Yes' ? '1' : '0'
      };

      // 1. Save to job_seekers table
      const jsResponse = await fetch(`${BaseUrl}/api/job-seeker`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      });

      const jsResult = await jsResponse.json();

      if (!jsResponse.ok) {
        throw new Error(jsResult.error || jsResult.message || 'Failed to save job seeker data');
      }

      // 2. Save to users table to ensure mobile_number and country code are updated
      // We need to fetch the current user first to get their password (since the update URL likes it)
      // or at least send the other required fields.
      const userDataUpdate = {
        ...userData, // Use existing user data if fetched
        first_name: userData?.first_name || formData.email_id.split('@')[0], // Fallback
        last_name: userData?.last_name || '',
        email: formData.email_id,
        mobile_number: formData.mobile_number,
        mobile_number_country_code: formData.mobile_country_code,
        whatsapp_number: formData.whatsapp_number,
        whatsapp_country_code: formData.whatsapp_country_code,
      };

      const userResponse = await fetch(`${BaseUrl}/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userDataUpdate),
      });

      if (!userResponse.ok) {
        try {
          const userResult = await userResponse.json();
          console.warn('Failed to update user table:', userResult.error || userResult.message);
        } catch (_) {
          console.warn('Failed to update user table. Status:', userResponse.status);
        }
        // We don't throw here to avoid failing the whole process if only user table update fails
      }

      await Swal.fire({
        title: 'Success!',
        text: 'Your contact information has been saved successfully.',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#3085d6',
      });

      setIsSaved(true);
      return jsResult;
    } catch (err) {
      console.error('Error saving data:', err);

      await Swal.fire({
        title: 'Error!',
        text: err.message || 'Failed to save data. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const focusOnField = (fieldName) => {
    setTimeout(() => {
      let element = null;

      switch (fieldName) {
        case 'email_id':
          element = emailRef.current;
          break;
        case 'mobile_number':
          element = mobileNumberRef.current;
          break;
        case 'whatsapp_number':
          element = whatsappNumberRef.current;
          break;
        case 'botim_number':
          element = botimNumberRef.current;
          break;
        case 'telegram_number':
          element = telegramNumberRef.current;
          break;
        case 'has_valid_passport':
          element = passportSectionRef.current;
          break;
        default:
          break;
      }

      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });

        if (fieldName !== 'has_valid_passport') {
          setTimeout(() => {
            element.focus();
            if (document.activeElement !== element) {
              element.focus();
            }
          }, 300);
        }
      }
    }, 100);
  };

  // In the validateFormData function, remove botim_number from required fields:
  const validateFormData = async () => {
    const requiredFields = [
      { field: 'email_id', name: 'Email', type: 'email' },
      { field: 'whatsapp_number', name: 'WhatsApp Number', type: 'number' }
      // Removed botim_number from required fields
    ];

    const missingFields = requiredFields.filter(item => !formData[item.field]);

    if (missingFields.length > 0) {
      const result = await Swal.fire({
        title: 'Error!',
        text: `Please fill in all required fields: ${missingFields.map(item => item.name).join(', ')}`,
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      if (result.isConfirmed || result.isDismissed) {
        const firstMissingField = missingFields[0];
        focusOnField(firstMissingField.field);
      }
      return false;
    }

    // Email validation
    if (formData.email_id && !/^\S+@\S+\.\S+$/.test(formData.email_id)) {
      const result = await Swal.fire({
        title: 'Error!',
        text: 'Please enter a valid email address',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      if (result.isConfirmed || result.isDismissed) {
        focusOnField('email_id');
      }
      return false;
    }

    // WhatsApp number validation (still required)
    if (formData.whatsapp_number && !/^[0-9]+$/.test(formData.whatsapp_number)) {
      const result = await Swal.fire({
        title: 'Error!',
        text: 'Please enter a valid WhatsApp number (digits only)',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      if (result.isConfirmed || result.isDismissed) {
        focusOnField('whatsapp_number');
      }
      return false;
    }

    // Botim number validation (now optional, only validate if provided)
    if (formData.botim_number && formData.botim_number.trim() !== '' && !/^[0-9]+$/.test(formData.botim_number)) {
      const result = await Swal.fire({
        title: 'Error!',
        text: 'Please enter a valid Botim number (digits only)',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      if (result.isConfirmed || result.isDismissed) {
        focusOnField('botim_number');
      }
      return false;
    }

    // Telegram number validation (optional)
    if (formData.telegram_number && !/^[0-9]+$/.test(formData.telegram_number)) {
      const result = await Swal.fire({
        title: 'Error!',
        text: 'Please enter a valid Telegram number (digits only)',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      if (result.isConfirmed || result.isDismissed) {
        focusOnField('telegram_number');
      }
      return false;
    }

    return true;
  };

  const handleSave = async () => {
    const isValid = await validateFormData();
    if (!isValid) return;

    try {
      await saveData();
    } catch (err) {
      // Error already handled in saveData
    }
  };

  const handleSaveNext = async () => {
    const isValid = await validateFormData();
    if (!isValid) return;

    try {
      await saveData();
      window.scrollTo(0, 0);
      navigate('/professionalinfo', { state: { userId, current_country } });
    } catch (err) {
      // Error already handled in saveData
    }
  };

  const CountryCodeDropdown = ({ field, value, onChange, required = false }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const filteredOptions = countryCodes.filter(item =>
      item.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.code.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const getDisplayText = (text) => {
      if (!text) return `Select Country code ${required ? '*' : ''} `;

      if (window.innerWidth <= 768) {
        const match = text.match(/^(\+\d+)\((.*)\)$/);
        if (match) {
          const [, code, country] = match;
          if (country.length > 10) {
            return `${code}(${country.substring(0, 8)}...) `;
          }
        }
      }
      return `${text} `;
    };

    return (
      <Dropdown show={isOpen} onToggle={isOpen => setIsOpen(isOpen)}>
        <Dropdown.Toggle
          variant="light"
          className="country-code-select w-100 text-start"
          title={value || "Select country code"}
        >
          <span className="dropdown-text">
            {getDisplayText(value)}
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="w-100" style={{ overflowY: 'hidden' }}>
          <div className="px-2 py-1">
            <Form.Control
              type="text"
              placeholder="Search country or code..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              autoFocus
              size="sm"
            />
          </div>
          <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map((item, index) => (
                <Dropdown.Item
                  key={index}
                  onClick={() => {
                    onChange(`${item.code}(${item.country})`);
                    setIsOpen(false);
                    setSearchTerm('');
                  }}
                  active={value === `${item.code}(${item.country})`}
                  className="text-truncate"
                  title={`${item.code} (${item.country})`}
                >
                  {item.code} ({item.country})
                </Dropdown.Item>
              ))
            ) : (
              <Dropdown.Item disabled>No matches found</Dropdown.Item>
            )}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  return (
    <>
      <Navbar />
      <div className="contact-wrapper" style={{ marginTop: "84px", width: '96%' }}>
        <Container className="mt-4 px-4 pb-5">
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          {success && (
            <div className="alert alert-success" role="alert">
              {success}
            </div>
          )}

          <Card className="shadow border-0 contact-details-card">
            <Card.Header className="contact-details-header">
              <h2 className="m-0 text-white text-center">
                <i className="bi bi-person-lines-fill me-2"></i>
                Details about yourself
              </h2>
            </Card.Header>
            <Card.Body className="contact-details-body">
              <h3 className="contact-detail-heading mb-4 fields-headingfont">Contact Detail</h3>

              <Form.Group className="mb-4">
                <Form.Control
                  ref={emailRef}
                  type="email"
                  name="email_id"
                  value={formData.email_id}
                  placeholder="Type email id here *"
                  onChange={handleChange}
                  className="contact-input contact-email-input"
                  required
                />
                {userData && (
                  <small className="text-muted">
                    {/* Fetched from your profile. You can edit if needed. */}
                  </small>
                )}
              </Form.Group>

              {/* Mobile Number - Read-only, from registration */}
              <div className="phone-input-group">
                <div className="country-code-wrapper">
                  <CountryCodeDropdown
                    field="mobile_country_code"
                    className="contactdetailscountrycode"
                    value={formData.mobile_country_code}
                    onChange={(value) => handleSelect('mobile_country_code', value)}
                    required={false}
                  />
                </div>
                <div className="phone-number-wrapper">
                  <Form.Control
                    ref={mobileNumberRef}
                    type="tel"
                    name="mobile_number"
                    value={formData.mobile_number}
                    onChange={handleChange}
                    placeholder="Mobile number (from registration)"
                    className="number-input"
                  />
                </div>
              </div>

              {/* WhatsApp - Mandatory */}
              <div className="phone-input-group">
                <div className="country-code-wrapper">
                  <CountryCodeDropdown
                    field="whatsapp_country_code"
                    className="contactdetailscountrycode"
                    value={formData.whatsapp_country_code}
                    onChange={(value) => handleSelect('whatsapp_country_code', value)}
                    required={true}
                  />
                </div>
                <div className="phone-number-wrapper">
                  <Form.Control
                    ref={whatsappNumberRef}
                    type="tel"
                    name="whatsapp_number"
                    value={formData.whatsapp_number}
                    onChange={handleChange}
                    placeholder="Type WhatsApp number here *"
                    className="number-input"
                    required
                  />
                  {userData && userData.mobile_number && (
                    <small className="text-muted">
                      {/* Pre-filled from your registered mobile number */}
                    </small>
                  )}
                </div>
              </div>

              {/* Botim - Now Optional */}
              <div className="phone-input-group">
                <div className="country-code-wrapper">
                  <CountryCodeDropdown
                    field="botim_country_code"
                    className="contactdetailscountrycode"
                    value={formData.botim_country_code}
                    onChange={(value) => handleSelect('botim_country_code', value)}
                    required={false}  // Changed from true to false
                  />
                </div>
                <div className="phone-number-wrapper">
                  <Form.Control
                    ref={botimNumberRef}
                    type="tel"
                    name="botim_number"
                    value={formData.botim_number}
                    onChange={handleChange}
                    placeholder="Type Botim number here (optional)"  // Updated placeholder
                    className="number-input"
                  // Removed the required attribute
                  />
                  {userData && userData.mobile_number && (
                    <small className="text-muted">
                      {/* Pre-filled from your registered mobile number */}
                    </small>
                  )}
                </div>
              </div>
              {/* Telegram - Optional */}
              <div className="phone-input-group">
                <div className="country-code-wrapper">
                  <CountryCodeDropdown
                    className="contactdetailscountrycode"
                    field="telegram_country_code"
                    value={formData.telegram_country_code}
                    onChange={(value) => handleSelect('telegram_country_code', value)}
                    required={false}
                  />
                </div>
                <div className="phone-number-wrapper">
                  <Form.Control
                    ref={telegramNumberRef}
                    type="tel"
                    name="telegram_number"
                    value={formData.telegram_number}
                    onChange={handleChange}
                    placeholder="Type Telegram number here (optional)"
                    className="number-input"
                  />
                </div>
              </div>

              <div className="mb-5" ref={passportSectionRef}>
                <h3 className="passport-question fields-headingfont">Do you have valid passport?</h3>
                <div className="row g-2 mt-3">
                  {['Yes', 'No'].map((option, index) => ( // Added 'Applied' option
                    <div className="col-6 col-md-6" key={index}> {/* Changed to col-md-4 for three buttons */}
                      <Button
                        className={`passport-btn w-100 ${formData.has_valid_passport === option ? 'selected' : ''}`}
                        onClick={() => handleSelect('has_valid_passport', option)}
                      >
                        {option}
                      </Button>
                    </div>
                  ))}
                </div>
              </div>
              <div className="additional-section mb-4" style={{ marginTop: '20px', padding: '0.5px' }}>
                <div className="d-flex justify-content-between gap-3 flex-row">
                  <button
                    type="button"
                    className="nav-btn" style={{ flex: 1 }}
                    onClick={() => navigate('/personalinfo', { state: { userId } })}
                    disabled={isLoading}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="nav-btn" style={{ flex: 1 }}
                    onClick={handleSaveNext}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Saving...' : 'Next'}
                  </button>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
}

export default ContactDetails;

